import 'core-js/stable';

document.addEventListener('DOMContentLoaded', function () {});
